import { QueryFunctionContext } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { GET, POST, PUT, DELETE } from '../../../redux/middleware/types'
import { amendmentKeys } from '../queries/amendmentQueryKeys'
import { Amendment } from '../../../types/amendment/Amendment'
import amendmentEndpoints from '../api/amendmentEndpoints'
import backendRequest from '../../../services/api/backendRequest'

export const fetchAmendmentList = async ({
  queryKey: [{ companyId, budgetingScenarioId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof amendmentKeys)['list']>>) => {
  return backendRequest<Amendment[]>({
    method: GET,
    url: amendmentEndpoints.list(companyId),
    params: { budgetingScenarioId },
    signal
  })
}

export const fetchAmendmentDetail = async ({
  queryKey: [{ companyId, amendmentId, budgetingScenarioId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof amendmentKeys)['detail']>>) => {
  return backendRequest<Amendment>({
    method: GET,
    url: amendmentEndpoints.detail(companyId, amendmentId!),
    params: { budgetingScenarioId },
    signal
  })
}

export const createAmendment = async (
  companyId: string,
  amendment: Partial<Amendment>,
  budgetingScenarioId?: number | null
) => {
  return backendRequest<Amendment>({
    method: POST,
    url: amendmentEndpoints.list(companyId),
    data: {
      ...amendment,
      date: amendment.date ? dayjs(amendment.date).format('YYYY-MM-DD') : undefined
    },
    params: { budgetingScenarioId }
  })
}

export const updateAmendment = async (companyId: string, amendment: Amendment) => {
  return backendRequest<Amendment>({
    method: PUT,
    url: amendmentEndpoints.detail(companyId, amendment.id),
    data: {
      ...amendment,
      date: amendment.date ? dayjs(amendment.date).format('YYYY-MM-DD') : undefined
    },
    params: { budgetingScenarioId: amendment.budgetingScenarioId }
  })
}

export const deleteAmendment = async (companyId: string, amendmentId: number) => {
  return backendRequest<void>({
    method: DELETE,
    url: amendmentEndpoints.detail(companyId, amendmentId)
  })
}
